import React from 'react'

import { AppearingWrapper, SubsectionTitle } from 'Components/Blocks'
import { Column } from 'Components/UI'

import { useResponsiveLayout } from 'Hooks'

function Title() {
  const { isMobile } = useResponsiveLayout()

  return (
    <Column alignCenter fullWidth maxWidth="1050px">
      <AppearingWrapper centered kind="expand">
        <SubsectionTitle
          centered
          title={`Who is Emajin for${
            isMobile ? '\n' : ' '
          }(and who it's not for)`}
        />
      </AppearingWrapper>
    </Column>
  )
}

export default Title
